export default "__VITE_ASSET__77c4e67b__"